import { Content, Portal, Root, Trigger } from '@radix-ui/react-popover';
import { forwardRef } from 'react';
import classNames from '@/lib/classNames';

const Popover = Root;

const PopoverTrigger = Trigger;

const PopoverContent = forwardRef<React.ElementRef<typeof Content>, React.ComponentPropsWithoutRef<typeof Content>>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
    <Portal>
        <Content
            ref={ref}
            align={align}
            sideOffset={sideOffset}
            className={classNames(
                'z-50 w-72 rounded-md border bg-white p-4 text-primary shadow-md outline-none animate-in data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                className
            )}
            {...props}
        />
    </Portal>
));
PopoverContent.displayName = Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
